import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';
import { useState } from 'react';

const RealisationsPage = () => {
  const [activeFilter, setActiveFilter] = useState('Tous');

  const categories = ['Tous', 'Impression Papier', 'Grand Format', 'Textile', 'Branding', 'Digital'];

  const realisations = [
    {
      category: 'Impression Papier',
      title: 'Cartes de Visite Luxe',
      client: 'Cabinet d\'Avocats Lumière',
      image: 'https://public.readdy.ai/ai/img_res/5f6a98254eb21f8767a72edac5327a70.jpg',
      description: 'Cartes de visite haut de gamme avec finition dorée'
    },
    {
      category: 'Branding',
      title: 'Identité Visuelle Complète',
      client: 'Restaurant Le Gourmet',
      image: 'https://readdy.ai/api/search-image?query=Complete%20brand%20identity%20package%20logo%20design%20menu%20brochures%20business%20cards%20restaurant%20branding%20materials%20elegant%20mockup%20professional%20photography&width=600&height=500&seq=real-brand-001&orientation=squarish',
      description: 'Logo, menus, cartes et supports marketing'
    },
    {
      category: 'Grand Format',
      title: 'Bâche Publicitaire',
      client: 'Centre Commercial Prestige',
      image: 'https://readdy.ai/api/search-image?query=Large%20format%20banner%20outdoor%20advertising%20signage%20commercial%20shopping%20center%20promotional%20display%20vibrant%20colors%20professional%20installation&width=600&height=500&seq=real-banner-001&orientation=squarish',
      description: 'Bâche extérieure 10m x 5m résistante'
    },
    {
      category: 'Textile',
      title: 'Uniformes Entreprise',
      client: 'Tech Solutions RDC',
      image: 'https://readdy.ai/api/search-image?query=Corporate%20uniforms%20custom%20printed%20polo%20shirts%20company%20logo%20professional%20apparel%20team%20clothing%20business%20attire%20clean%20background%20studio%20photography&width=600&height=500&seq=real-textile-001&orientation=squarish',
      description: 'Polos et t-shirts personnalisés pour équipe'
    },
    {
      category: 'Impression Papier',
      title: 'Brochures Premium',
      client: 'Agence Immobilière Elite',
      image: 'https://readdy.ai/api/search-image?query=Premium%20brochures%20real%20estate%20marketing%20materials%20glossy%20finish%20professional%20design%20property%20catalog%20elegant%20layout%20studio%20photography&width=600&height=500&seq=real-brochure-001&orientation=squarish',
      description: 'Catalogues immobiliers avec finition brillante'
    },
    {
      category: 'Grand Format',
      title: 'Roll-Up Événementiel',
      client: 'Conférence Internationale',
      image: 'https://readdy.ai/api/search-image?query=Roll-up%20banner%20stands%20event%20display%20professional%20conference%20signage%20portable%20displays%20trade%20show%20materials%20modern%20design%20studio%20photography&width=600&height=500&seq=real-rollup-001&orientation=squarish',
      description: 'Série de roll-ups pour événement corporate'
    },
    {
      category: 'Branding',
      title: 'Packaging Produit',
      client: 'Cosmétiques Naturels',
      image: 'https://readdy.ai/api/search-image?query=Product%20packaging%20design%20cosmetics%20boxes%20elegant%20branding%20natural%20beauty%20products%20premium%20packaging%20mockup%20professional%20photography%20studio%20lighting&width=600&height=500&seq=real-package-001&orientation=squarish',
      description: 'Design et impression d\'emballages élégants'
    },
    {
      category: 'Digital',
      title: 'Site E-commerce',
      client: 'Boutique Mode Africaine',
      image: 'https://readdy.ai/api/search-image?query=E-commerce%20website%20design%20fashion%20store%20online%20shopping%20interface%20modern%20web%20design%20African%20fashion%20boutique%20professional%20mockup%20laptop%20screen&width=600&height=500&seq=real-web-001&orientation=squarish',
      description: 'Création site web et stratégie marketing'
    },
    {
      category: 'Textile',
      title: 'Casquettes Promotionnelles',
      client: 'Festival Musical 2024',
      image: 'https://readdy.ai/api/search-image?query=Custom%20printed%20caps%20promotional%20merchandise%20event%20branding%20festival%20accessories%20embroidered%20hats%20marketing%20materials%20studio%20photography%20white%20background&width=600&height=500&seq=real-caps-001&orientation=squarish',
      description: 'Casquettes brodées pour événement'
    }
  ];

  const filteredRealisations = activeFilter === 'Tous'
    ? realisations
    : realisations.filter(item => item.category === activeFilter);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 overflow-hidden bg-gradient-to-br from-black via-[#2D3142] to-black">
        <div className="relative z-10 max-w-7xl mx-auto px-6 text-center">
          <span className="inline-block bg-[#E63946]/20 text-[#E63946] px-6 py-2 rounded-full text-sm font-semibold mb-6">
            NOS RÉALISATIONS
          </span>
          <h1 className="text-white text-6xl lg:text-7xl font-black mb-6">
            Portfolio de<br />
            <span className="text-[#E63946]">Projets Réussis</span>
          </h1>
          <p className="text-gray-300 text-xl max-w-3xl mx-auto leading-relaxed">
            Découvrez une sélection de nos meilleurs travaux d'impression et de branding réalisés pour nos clients satisfaits.
          </p>
        </div>
      </section>

      {/* Filter Section */}
      <section className="py-12 bg-[#F8F9FA] sticky top-20 z-40">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex flex-wrap gap-4 justify-center">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setActiveFilter(category)}
                className={`px-6 py-3 rounded-full font-semibold text-sm transition-all duration-300 whitespace-nowrap cursor-pointer ${
                  activeFilter === category
                    ? 'bg-[#E63946] text-white shadow-lg scale-105'
                    : 'bg-white text-gray-700 hover:bg-gray-100'
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="py-20 bg-white" data-product-shop>
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredRealisations.map((item, index) => (
              <div
                key={index}
                className="group cursor-pointer bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
              >
                <div className="relative overflow-hidden aspect-[4/3]">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <div className="absolute bottom-6 left-6 right-6">
                      <span className="inline-block bg-[#E63946] text-white text-xs font-semibold px-3 py-1 rounded-full mb-3">
                        {item.category}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="p-6">
                  <span className="text-[#E63946] text-xs font-semibold uppercase tracking-wide">
                    {item.category}
                  </span>
                  <h3 className="text-black text-xl font-bold mt-2 mb-2">
                    {item.title}
                  </h3>
                  <p className="text-gray-600 text-sm mb-3">
                    <i className="ri-building-line mr-2"></i>
                    {item.client}
                  </p>
                  <p className="text-gray-700 text-sm leading-relaxed">
                    {item.description}
                  </p>
                </div>
              </div>
            ))}
          </div>

          {filteredRealisations.length === 0 && (
            <div className="text-center py-20">
              <i className="ri-folder-open-line text-gray-300 text-6xl mb-4"></i>
              <p className="text-gray-500 text-lg">
                Aucune réalisation trouvée dans cette catégorie
              </p>
            </div>
          )}
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-20 bg-gradient-to-br from-black via-[#2D3142] to-black">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-white text-5xl font-bold mb-4">
              Nos Chiffres Clés
            </h2>
            <p className="text-gray-300 text-lg">
              Des résultats qui parlent d'eux-mêmes
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {[
              { number: '500+', label: 'Clients Satisfaits' },
              { number: '5000+', label: 'Projets Réalisés' },
              { number: '10+', label: 'Ans d\'Expérience' },
              { number: '98%', label: 'Taux de Satisfaction' }
            ].map((stat, index) => (
              <div key={index} className="text-center">
                <p className="text-[#E63946] text-5xl font-black mb-3">
                  {stat.number}
                </p>
                <p className="text-gray-300 text-base">
                  {stat.label}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-[#F8F9FA]">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-black text-5xl font-bold mb-6">
            Votre Projet Sera le Prochain
          </h2>
          <p className="text-gray-700 text-lg mb-10">
            Contactez-nous pour discuter de votre projet d'impression
          </p>
          <div className="flex flex-wrap gap-5 justify-center">
            <Link
              to="/commande-devis"
              className="bg-[#E63946] text-white px-10 py-4 rounded-full font-bold text-base shadow-2xl hover:bg-[#d32f3c] transition-all duration-300 hover:scale-105 flex items-center gap-2 whitespace-nowrap cursor-pointer"
            >
              Demander un Devis
              <i className="ri-arrow-right-line"></i>
            </Link>
            <Link
              to="/services"
              className="border-2 border-black text-black px-10 py-4 rounded-full font-bold text-base hover:bg-black hover:text-white transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Voir nos Services
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default RealisationsPage;